import React from 'react'
import Modal from 'LuxKit/Modal/Modal'
import styled from 'styled-components'
import { rem } from 'polished'
import BodyText from 'LuxKit/Typography/BodyText'
import { INTL_DATE_TIME_FORMAT } from 'constants/dateFormats'
import { useIntlDateFormatter } from 'lib/datetime/dateUtils'
import HelpPane from 'components/Common/HelpPane'
import { FormattedMessage, useIntl } from 'react-intl'

const ModalContent = styled.div`
  padding-top: ${rem(16)};
`

interface Props {
  checkInDate?: string | moment.Moment
  startDate?: moment.Moment
}

function OfferPropertyCancellationPolicyModal(props: Props) {
  const {
    checkInDate,
    startDate,
  } = props

  const intl = useIntl()
  const intlDateFormatter = useIntlDateFormatter()

  return <Modal
    title={intl.formatMessage({
      id: 'h+kYDcWxEf',
      defaultMessage: 'Free cancellation',
      description: 'Title for free cancellation modal',
    })}
  >
    <ModalContent>
      {!checkInDate && <BodyText variant="medium" as="p">
        <FormattedMessage
          id="JVer4HCwN8"
          defaultMessage="Things don't always work out. Our 7-day 'change of mind' guarantee is there to help."
          description="First sentence of free cancellation policy description"
        />
        {' '}
        <FormattedMessage
          id="vep4uYYXhN"
          defaultMessage="Limited Time Lux Exclusive bookings (excluding flights) may be cancelled with a full refund provided that cancellation occurs strictly within 7 days from the date of purchase and provided that the cancellation is made no less than 14 days prior to the check-in date."
          description="Second sentence of free cancellation policy description"
        />
        {' '}
        <FormattedMessage
          id="ZmcQkRU2Rp"
          defaultMessage="Please note: flights and experiences are subject to the refund policies of the respective operator."
          description="Third sentence of free cancellation policy description"
        />
      </BodyText>}
      {checkInDate && startDate && <BodyText variant="medium" as="p">
        {intl.formatMessage(
          {
            id: 'pO3aWV9NqV',
            defaultMessage: 'Standard bookings can be cancelled with a full refund provided the cancellation is made by {date} (local time of property).',
            description: 'Description of free cancellation policy with check-in date',
          },
          {
            date: intlDateFormatter(startDate, INTL_DATE_TIME_FORMAT),
          },
        )}
      </BodyText>}
      <HelpPane />
    </ModalContent>
  </Modal>
}

export default OfferPropertyCancellationPolicyModal
